export const PERMISSION_ADMIN = "com.mediamath.whitelabel.admin";
export const MAX_CAMPAIGN_DURATION_MONTHS = 36;

export const default1PSeller = {
  key: "0",
  text: "1P",
  value: "0",
};
